import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u049A\u0430\u0437\u0430\u049B\u0448\u0430",
  code: "kk",
  messages: {
    alert: {
      close: "\u0416\u0430\u0431\u0443"
    },
    authForm: {
      hidePassword: "\u049A\u04B1\u043F\u0438\u044F \u0441\u04E9\u0437\u0434\u0456 \u0436\u0430\u0441\u044B\u0440\u0443",
      showPassword: "\u049A\u04B1\u043F\u0438\u044F \u0441\u04E9\u0437\u0434\u0456 \u043A\u04E9\u0440\u0441\u0435\u0442\u0443",
      submit: "\u0416\u0430\u043B\u0493\u0430\u0441\u0442\u044B\u0440\u0443"
    },
    banner: {
      close: "\u0416\u0430\u0431\u0443"
    },
    calendar: {
      nextMonth: "\u041A\u0435\u043B\u0435\u0441\u0456 \u0430\u0439",
      nextYear: "\u041A\u0435\u043B\u0435\u0441\u0456 \u0436\u044B\u043B",
      prevMonth: "\u0410\u043B\u0434\u044B\u04A3\u0493\u044B \u0430\u0439",
      prevYear: "\u0410\u043B\u0434\u044B\u04A3\u0493\u044B \u0436\u044B\u043B"
    },
    carousel: {
      dots: "\u041A\u04E9\u0440\u0441\u0435\u0442\u0443 \u04AF\u0448\u0456\u043D \u0441\u043B\u0430\u0439\u0434\u0442\u044B \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
      goto: "{slide} \u0441\u043B\u0430\u0439\u0434\u049B\u0430 \u04E9\u0442\u0443",
      next: "\u041A\u0435\u043B\u0435\u0441\u0456",
      prev: "\u0410\u043B\u0434\u044B\u04A3\u0493\u044B"
    },
    chatPrompt: {
      placeholder: "\u0425\u0430\u0431\u0430\u0440 \u0435\u043D\u0433\u0456\u0437\u0456\u04A3\u0456\u0437..."
    },
    chatPromptSubmit: {
      label: "\u0416\u0456\u0431\u0435\u0440\u0443"
    },
    colorMode: {
      dark: "\u049A\u0430\u0440\u0430\u04A3\u0493\u044B",
      light: "\u0410\u0448\u044B\u049B",
      switchToDark: "\u049A\u0430\u0440\u0430\u04A3\u0493\u044B \u0440\u0435\u0436\u0438\u043C\u0433\u0435 \u0430\u0443\u044B\u0441\u0443",
      switchToLight: "\u0410\u0448\u044B\u049B \u0440\u0435\u0436\u0438\u043C\u0433\u0435 \u0430\u0443\u044B\u0441\u0443",
      system: "\u0416\u04AF\u0439\u0435"
    },
    commandPalette: {
      back: "\u0410\u0440\u0442\u049B\u0430",
      close: "\u0416\u0430\u0431\u0443",
      noData: "\u0414\u0435\u0440\u0435\u043A\u0442\u0435\u0440 \u0436\u043E\u049B",
      noMatch: "\u0421\u04D9\u0439\u043A\u0435\u0441 \u043A\u0435\u043B\u0435\u0442\u0456\u043D \u0434\u0435\u0440\u0435\u043A\u0442\u0435\u0440 \u0436\u043E\u049B",
      placeholder: "\u041A\u043E\u043C\u0430\u043D\u0434\u0430 \u0435\u043D\u0433\u0456\u0437\u0456\u04A3\u0456\u0437 \u043D\u0435\u043C\u0435\u0441\u0435 \u0456\u0437\u0434\u0435\u04A3\u0456\u0437..."
    },
    contentSearch: {
      links: "\u0421\u0456\u043B\u0442\u0435\u043C\u0435\u043B\u0435\u0440",
      theme: "\u0422\u0430\u049B\u044B\u0440\u044B\u043F"
    },
    contentSearchButton: {
      label: "\u0406\u0437\u0434\u0435\u0443"
    },
    contentToc: {
      title: "\u041C\u0430\u0437\u043C\u04B1\u043D\u044B"
    },
    dashboardSearch: {
      theme: "\u0422\u0430\u049B\u044B\u0440\u044B\u043F"
    },
    dashboardSearchButton: {
      label: "\u0406\u0437\u0434\u0435\u0443"
    },
    dashboardSidebarCollapse: {
      collapse: "\u0416\u0438\u044E",
      expand: "\u041A\u0435\u04A3\u0435\u0439\u0442\u0443"
    },
    dashboardSidebarToggle: {
      close: "\u0416\u0430\u0431\u0443",
      open: "\u0410\u0448\u0443"
    },
    error: {
      clear: "\u0422\u0430\u0437\u0430\u043B\u0430\u0443"
    },
    fileUpload: {
      removeFile: "{filename} \u0436\u043E\u044E"
    },
    header: {
      close: "\u0416\u0430\u0431\u0443",
      open: "\u0410\u0448\u0443"
    },
    inputMenu: {
      create: '"{label}" \u0436\u0430\u0441\u0430\u0443',
      noData: "\u0414\u0435\u0440\u0435\u043A\u0442\u0435\u0440 \u0436\u043E\u049B",
      noMatch: "\u0421\u04D9\u0439\u043A\u0435\u0441 \u043A\u0435\u043B\u0435\u0442\u0456\u043D \u0434\u0435\u0440\u0435\u043A\u0442\u0435\u0440 \u0436\u043E\u049B"
    },
    inputNumber: {
      decrement: "\u0410\u0437\u0430\u0439\u0442\u0443",
      increment: "\u0410\u0440\u0442\u0442\u044B\u0440\u0443"
    },
    modal: {
      close: "\u0416\u0430\u0431\u0443"
    },
    pricingTable: {
      caption: "\u0411\u0430\u0493\u0430 \u043A\u0435\u0441\u0442\u0435\u0441\u0456"
    },
    prose: {
      codeCollapse: {
        closeText: "\u0416\u0438\u044B\u0440\u0443",
        name: "\u043A\u043E\u0434",
        openText: "\u041A\u0435\u04A3\u0435\u0439\u0442\u0443"
      },
      collapsible: {
        closeText: "\u0416\u0430\u0441\u044B\u0440\u0443",
        name: "\u049B\u0430\u0441\u0438\u0435\u0442\u0442\u0435\u0440",
        openText: "\u041A\u04E9\u0440\u0441\u0435\u0442\u0443"
      },
      pre: {
        copy: "\u041A\u043E\u0434\u0442\u044B \u0430\u043B\u043C\u0430\u0441\u0443 \u0431\u0443\u0444\u0435\u0440\u0456\u043D\u0435 \u043A\u04E9\u0448\u0456\u0440\u0443"
      }
    },
    selectMenu: {
      create: '"{label}" \u0436\u0430\u0441\u0430\u0443',
      noData: "\u0414\u0435\u0440\u0435\u043A\u0442\u0435\u0440 \u0436\u043E\u049B",
      noMatch: "\u0421\u04D9\u0439\u043A\u0435\u0441 \u043A\u0435\u043B\u0435\u0442\u0456\u043D \u0434\u0435\u0440\u0435\u043A\u0442\u0435\u0440 \u0436\u043E\u049B",
      search: "\u0406\u0437\u0434\u0435\u0443..."
    },
    slideover: {
      close: "\u0416\u0430\u0431\u0443"
    },
    table: {
      noData: "\u0414\u0435\u0440\u0435\u043A\u0442\u0435\u0440 \u0436\u043E\u049B"
    },
    toast: {
      close: "\u0416\u0430\u0431\u0443"
    }
  }
});
